import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner';
import React , { Fragment } from 'react';
import {useRouter} from 'next/router'
import Tabs from '../../components/common/Tabs/Tabs';
import {trackPage} from "../../tracking/index";
import Config from '../../config';
import {getStaticPath} from '../../utils';
import dynamic from "next/dynamic";
import { getPageViewData } from '../../utils/tracking';

const TermsOfUse = dynamic(()=> import('../../components/terms-of-use/index'),
{loading: () => <p className="loading-box"></p>,ssr:true }
);

export async function getServerSideProps() {
  return {
    props: { pageName: 'terms-of-use' }
  }
}


export default function Home() {
  const router = useRouter()
  const BASE_URL = Config.BASE_URL;
  const OG_IMAGE = getStaticPath("/static/images/why-onsitego.svg")
  const onTabClick = (id:any) =>{
    router.push(`/${id}`)
  }
  React.useEffect(()=>{
    trackPage("Terms Of Use",{...getPageViewData()})
},[])
  
  return (
    <Fragment>
      <Head>
        <title>Terms and Conditions | Onsitego</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content={"Terms & conditions, including copyright and trademark information for Onsitego."}></meta>
        <meta property="og:title" content="Terms and Conditions | Onsitego"/>
        <meta property="og:description" content={"Terms & conditions, including copyright and trademark information for Onsitego."}/>
        <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
        <meta property="og:image" content={OG_IMAGE}/>
        <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
      </Head>
      <PlainBanner title="Terms of Use - Onsitego" />
      <TermsOfUse />
    </Fragment>
  )
}